<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'PenghargaanDetail',

    metaInfo: { title: 'Penghargaan' },

    extends: View,

    mixins: [
      LoadSections([
        'awards-detail',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'awardsdetail',
      },
    },
  }
</script>
